import { useEffect } from 'react'

const BASE_TITLE = 'CommanderBracket'

export function usePageMeta(title: string, description?: string) {
  useEffect(() => {
    document.title = `${title} | ${BASE_TITLE}`

    if (description) {
      const meta = document.querySelector('meta[name="description"]')
      // eslint-disable-next-line i18next/no-literal-string -- page meta stays English (SEO), as ROUTE_META does
      if (meta) meta.setAttribute('content', description)
    }

    return () => {
      // eslint-disable-next-line i18next/no-literal-string -- page meta stays English (SEO), as ROUTE_META does
      document.title = `${BASE_TITLE} - Free MTG Commander Power Level & Bracket Analysis`
    }
  }, [title, description])
}
